import { render, staticRenderFns } from "./CertificationsSection.vue?vue&type=template&id=1a3531fe&scoped=true&"
import script from "./CertificationsSection.vue?vue&type=script&lang=js&"
export * from "./CertificationsSection.vue?vue&type=script&lang=js&"
import style0 from "./CertificationsSection.vue?vue&type=style&index=0&id=1a3531fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3531fe",
  null
  
)

export default component.exports